module.exports = __webpack_public_path__ + "static/logo-caf-png-2cb605c278b8ba1981865915a04d949f.png";